import getSortedUnfilledPopupIds from './getSortedUnfilledPopupIds';
import isFilledPopup from './isFilledPopup';

const allSignaturesFilled = (popups, activePopup, sortedUnfilledPopupIds) => (
  sortedUnfilledPopupIds.length === 0 ||
  (
    sortedUnfilledPopupIds.length === 1 &&
    sortedUnfilledPopupIds[0] === activePopup &&
    isFilledPopup(popups[activePopup])
  )
);

const getNextUnfilledPopupId = (popups, activePopup) => {
  const sortedUnfilledPopupIds = getSortedUnfilledPopupIds(Object.values(popups), activePopup);
  if (allSignaturesFilled(popups, activePopup, sortedUnfilledPopupIds)) {
    return null;
  }
  if (activePopup) {
    const activePopupIndex = sortedUnfilledPopupIds.indexOf(activePopup);
    if (activePopupIndex < (sortedUnfilledPopupIds.length - 1)) {
      return sortedUnfilledPopupIds[activePopupIndex + 1];
    }
  }
  return sortedUnfilledPopupIds[0];
};

export default getNextUnfilledPopupId;



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/getNextUnfilledPopupId.jsx